module.exports = __webpack_public_path__ + "img/zjk-Upload avatar@2x.207c13b5.png";